import { render, staticRenderFns } from "./FixedBearings.vue?vue&type=template&id=1db2a819&scoped=true"
import script from "./FixedBearings.vue?vue&type=script&lang=js"
export * from "./FixedBearings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db2a819",
  null
  
)

export default component.exports